module.exports = __webpack_public_path__ + "static/media/time.0b6151af.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/time.png
// module id = 208
// module chunks = 0